import { render, staticRenderFns } from "./EditEvento.vue?vue&type=template&id=16d2f726&"
import script from "./EditEvento.vue?vue&type=script&lang=js&"
export * from "./EditEvento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports